import { styled } from '@material-ui/core/styles';

export const Root = styled('div')({
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
  minHeight: '100%',
});
